<template>
  <div>
    <v-dialog width="800" v-model="showchange">
      <template v-slot:activator="{ on }">
        <v-btn
          flat
          outline
          class="primary mr-2 hidden-xs-only"
          :style="`line-height: 10px;color: ${$vuetify.theme.primary};`"
          v-on="on"
          v-if="!$store.state.isFacebook"
          >{{ $t('change password') }}</v-btn
        >
        <v-btn
          fab
          small
          outline
          class="primary mr-2 hidden-sm-and-up"
          :style="`line-height: 10px;color: ${$vuetify.theme.primary};`"
          v-on="on"
          v-if="!$store.state.isFacebook"
        >
          <v-icon small>vpn_key</v-icon></v-btn
        >
      </template>
      <v-card v-if="showchange">
        <v-container>
          <v-card-text>
            <h1>{{ $t('Change Password') }}</h1>
            <form class="form-control" :class="{ 'has-error': errors.has('password') }">
              <label>{{ $t('New password') }}</label>
              <input
                v-validate="'required'"
                name="password"
                type="password"
                :data-vv-as="$t('password')"
                v-model.trim="password"
                autocomplete="on"
                ref="password"
              />
              <span class="text-error" v-if="errors.has('password')">{{
                errors.first('password')
              }}</span>
            </form>
            <form class="form-control" :class="{ 'has-error': errors.has('passwordconfirm') }">
              <label>{{ $t('Confirm password') }}</label>
              <input
                v-validate="'required|confirmed:password'"
                name="passwordconfirm"
                :data-vv-as="$t('password')"
                type="password"
                autocomplete="on"
                v-model.trim="confirmpassword"
              />
              <span class="text-error" v-if="errors.has('passwordconfirm')">{{
                errors.first('passwordconfirm')
              }}</span>
            </form>
            <div class="text-xs-center">
              <v-btn @click="cancel" outline color="grey">{{ $t('cancel') }}</v-btn>
              <v-btn
                @click="changepassword"
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                >{{ $t('Save') }}</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      showchange: false,
      loading: false,
      password: '',
      confirmpassword: ''
    }
  },
  computed: {
    ...mapGetters(['isFacebook', 'currentLang'])
  },
  methods: {
    cancel() {
      //   this.password = ''
      //   this.confirmpassword = ''
      this.showchange = false
    },
    changepassword() {
      var vm = this
      var data = { password: this.confirmpassword }
      this.loading = true
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          return false
        }

        api.changepasswordadminuser(data, (error, response) => {
          if (error) console.error(error)
          this.loading = false
          if (response.responsecode == 200) {
            vm.$swal
              .fire({
                type: 'success',
                title: vm.$t('Success')
              })
              .then(() => {
                vm.$store.dispatch('logout', null).then()
                if (vm.isFacebook) {
                  vm.$router.push('/' + vm.currentLang + '/login')
                } else {
                  vm.$router.push('/' + vm.currentLang + '/nigol')
                }
              })
          }
        })
      })
    }
  }
}

// onChangePassword() {
//   let vm = this
//   vm.$validator.validate().then(result => {
//     if (!result) {
//       // do stuff if not valid.
//       return false
//     }
//     let obj = {
//       adminid: vm.$store.state.userid,
//       password: vm.input.password
//     }
//     api.changepasswordadminuser({ obj }, (err, response) => {
//       if (err) console.error(err)
//       var isFacebook = vm.isFacebook
//       vm.$store.dispatch('logout', null).then()
//       if (isFacebook) {
//         vm.$router.push('/' + vm.currentLang + '/login')
//       } else {
//         vm.$router.push('/' + vm.currentLang + '/nigol')
//       }
//     })
//   })
// },
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/ChangePassword.vue